import { Container } from '../../components';
import NFTDivided from './nft-divided';
import styles from './nft-withdrawal.module.css';

function NFTWithdrawal() {
  return (
    <section className={styles.section}>
      <Container variant="container_medium">
        <NFTDivided />
        <div className={styles.inner}>
          <h1 className={styles.title}>Withdrawal</h1>
          <p className={styles.text}>
            The development of blockchain technology does not plan to stop, its
            advantage is growing every day, and you probably already felt it. A
            great option for today is to develop your own NFT marketplace for an
            existing business or to create a new one. While the market is not
            filled with a huge number of NFT platforms, create your own to be
            ahead of the competition and get your benefits.
          </p>
        </div>
      </Container>
    </section>
  );
}

export default NFTWithdrawal;
